import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { MainFormPage } from '../MainFormPage';
import { initialDataSlice } from '../../store/initialData/initialData.slice';
import { BugsnagService } from '../../services/Bugsnag.service';
var mapDispatchToProps = function (dispatch) { return ({
    setReferralData: function (type, id) {
        return dispatch(initialDataSlice.actions.setReferralData({ type: type, id: id }));
    },
    resetReferralData: function () {
        return dispatch(initialDataSlice.actions.resetReferralData());
    },
}); };
var RawReferralPage = function (_a) {
    var type = _a.type, id = _a.id, setReferralData = _a.setReferralData, resetReferralData = _a.resetReferralData;
    var referralIdUrlParam = useParams().referralIdUrlParam;
    var idToPass = id || referralIdUrlParam;
    useEffect(function () {
        if (typeof type === 'string' && typeof idToPass === 'string') {
            setReferralData(type, idToPass);
        }
        else {
            BugsnagService.emitHandledError('ReferralPage was rendered, but "type" OR "id" was not provided');
        }
        return function onUnmount() {
            resetReferralData();
        };
    });
    return React.createElement(MainFormPage, null);
};
export var ReferralPage = connect(null, mapDispatchToProps)(RawReferralPage);
